import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export default function Wysiwyg({module, field, onChange, errors = {}, value, small = false, toolbar = {}, toolbarCustomButtons = [], toolbarHidden = false,height='30vh',disabled=false }) {
	const classes = useStyles();
	const [editorState, setEditorState] = useState(EditorState.createEmpty());
	let iserror = errors[field.name] ? true : false;
	let isRequired = field.required === 'true' ? " *" : "";
	useEffect(() => {
		if (toHtml(editorState) === value) return;
		if(!value.id){
		setEditorState(EditorState.push(
			editorState,
			ContentState.createFromBlockArray(
				htmlToDraft(value || ''),
			),
		)
		)
			}
	}, [value]);

	const onEditorStateChange = editorState => {
		setEditorState(editorState);
		const html = toHtml(editorState)
		onChange(html)

	};

	const toHtml = editorState => {
		return draftToHtml(convertToRaw(editorState.getCurrentContent())) // added
	}

	return (
		<>
		{module!=='Emails'?<h3 style={{margin: "0.5vw",fontWeight:"400",display:"flex"}}>{field.label ? field.label.replace(/^./, field.label[0].toUpperCase()) : field?.name.replace(/^./, field.name[0].toUpperCase())}</h3>:""}
		<Editor
			id={field.name}
			name={field.name}
			error={iserror}
			// className={classes.wysiwygToolbox}
			editorState={editorState}
			// defaultContentState={editorState}
			toolbarClassName={classes.wysiwygToolbox}
			wrapperClassName={classes.wysiwygWrapper}
			editorClassName={classes.wysiwygEditorBox}
			onEditorStateChange={onEditorStateChange}
			toolbar={toolbar}
			toolbarCustomButtons={toolbarCustomButtons}
			toolbarHidden={toolbarHidden}
			editorStyle={{height:height}}
			readOnly={disabled} 
		/>
		</>
	);
}
